import React, { useState, useEffect, useCallback, useRef } from "react";
import MessageIcon from "@mui/icons-material/Message";
import Box from "@mui/material/Box";
// import CardMedia from "@mui/material/CardMedia";
import { Button, Card, Divider, p, Typography } from "@mui/material";
// import TextField from "@mui/material/TextField";
import { keyframes } from "@mui/system";
import { styled } from "@mui/material/styles";
import NoImage from "../../images/resources/noImage.jpg";
import theme from "./theme";
import { auctionsLive } from "../../Model/Auction";
import "./Center.css";
import Chat from "./chat";
import Drawer from "./drawer";
import useMediaQuery from "@mui/material/useMediaQuery";
import { getUser } from "../../Model/LocalStorage";
import PlayCircleIcon from '@mui/icons-material/PlayCircle';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Paper, { PaperProps } from '@mui/material/Paper';
import Draggable from 'react-draggable';

function PaperComponent(props) {
  const nodeRef = React.useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
}

// import CardContent from "@mui/material/CardContent";
// import CardMedia from "@mui/material/CardMedia";
// import IconButton from "@mui/material/IconButton";
// import SkipPreviousIcon from "@mui/icons-material/SkipPrevious";
// import VideocamIcon from '@mui/icons-material/Videocam';
// import SkipNextIcon from "@mui/icons-material/SkipNext";
// import { WebRTCPlayer } from "@eyevinn/webrtc-player";

const blink = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const BlinkedBox = styled("div")({
  color: "red",
  animation: `${blink} 1s linear infinite`,
});

// document.addEventListener("visibilitychange", () => {
//   if (document.visibilityState === "visible") {
//     // Reinitialize or reload the Wowza WebRTC player
//     // console.log("Tab is active again. Reconnecting the player...");
//     reconnectPlayer();
//   }
// });

// async function reconnectPlayer() {

//   try {
//     const videos = document.querySelector("video");
//   const player = new WebRTCPlayer({
//     video: videos,
//     // timeoutThreshold: 3000,
//     type: "whep",

//   });

//   // console.log("player ",player)

//   await player.load(
//     new URL(
//       "https://customer-gc73aqvl9oq83lia.cloudflarestream.com/359346f60f669e61d8b1efb7353292da/webRTC/play"
//     )
//   );
//   player.unmute();

//   player.on("no-media", () => {
//     console.log("media timeout occured");
//   });
//   player.on("media-recovered", () => {
//     console.log("media recovered");
//   });

//   // Subscribe for RTC stats: `stats:${RTCStatsType}`
//   player.on("stats:inbound-rtp", (report) => {
//     if (report.kind === "video") {
//      // console.log("report");

//     }

//   });
//   } catch (error) {

//   }

// }

const  Midlayout = ({
  details,
  socket,
  mediadQuery,
  titleAuction,
}) => {
  const classes = theme();
  const videoRef = (useRef < HTMLVideoElement) | (null > null);
  const [sold, setSold] = useState("");
  const [getData, setGetData] = useState([]);
  const [image, setImage] = useState([]);
  const [status, setStatus] = useState("");
  const [announcement, setAnnouncement] = useState("");
  const [switchMode, setSwitch] = useState(true);
  const matchesPhone = useMediaQuery("(min-width:700px)");
  const [more, setMore] = useState(false);
  const [lotnumber, setLotNumber] = useState(null);
  const [username, setUsername] = useState("");

  const handleMore = () => {
    setMore(!more);
  };
  const ListData = useCallback((val) => {

    async function getAuctionOne() {
      const results = await auctionsLive();

      if (results.success === true) {
        setSold("");
        // console.log("results ",results)
        setGetData(results.lot.details);
        setLotNumber(results.lot.details[0].lot_number);
        setImage(results.lot.image_lot);
      } else {
      }
    }
    getAuctionOne().catch(console.error);
  },[])


  const [userID, setUserID] = useState("");
    



  useEffect(() => {
    // reconnectPlayer();
    async function getUserList() {
      const getuser = await getUser();
      setUserID(getuser.id);
      setUsername(getuser.email);
      socket.emit("ConnectedUser", {
        userId: getuser.id,
        email: getuser.email,
      });
    }
    getUserList().catch(console.error);
    try {



      setStatus(details.lot.details[0].lot_status);

      if (details.lot.details[0].lot_status === "SOLD") {
        setSold(
          <div className="overlay11" style={{ color: "#59bb59" }}>
            <div className="statusCss">SOLD</div>
          </div>
        );
      } else if (details.lot.details[0].lot_status === "UNSOLD") {
        setSold(
          <div className="overlay11" style={{ color: "#ff4949" }}>
            <div className="statusUnsold">UNSOLD</div>
          </div>
        );
      } else if (details.lot.details[0].lot_status === "PASS") {
        setSold(
          <div className="overlay11" style={{ color: "#0bf8bf" }}>
            PASS
          </div>
        );
      } else if (details.lot.details[0].lot_status === "RESERVE_NOT_MET") {
        setSold(
          <div className="overlay11" style={{ color: "#fffd00" }}>
            <div
              className="statusUnsold"
              style={{ lineHeight: "normal", fontSize: 45 }}
            >
              RESERVE NOT MET
            </div>
          </div>
        );
      } else {
        setSold("");
      }
      setImage(details.lot.image_lot);
      setAnnouncement(details.announcement[0].announcement);
      setGetData(details.lot.details);
      setLotNumber(details.lot.details[0].lot_number);
    } catch (error) {
      // setImage("");
      setGetData([]);
    }

    socket.on("receiveMessage", (data) => {
      // alert("receive_status 2")
      setAnnouncement(data.message);
    });

    socket.on("receive_status", (data) => {
      // alert(data.message)
      if (data.message === "SOLD") {
        setSold(
          <div className="overlay11" style={{ color: "#59bb59" }}>
            <div className="statusCss">SOLD</div>
          </div>
        );
      } else if (data.message === "UNSOLD") {
        setSold(
          <div className="overlay11" style={{ color: "#ff4949" }}>
            <div className="statusUnsold">UNSOLD</div>
          </div>
        );
        // } else if (data.message === "PASS") {
        //   setSold(
        //     <div className="overlay11" style={{ color: "#0bf8bf" }}>
        //         <div className="statusUnsold">PASS</div>
        //     </div>
        //   );
      } else if (data.message === "RESERVE_NOT_MET") {
        setSold(
          <div className="overlay11" style={{ color: "#fffd00" }}>
            <div
              className="statusUnsold"
              style={{ lineHeight: "normal", fontSize: 45 }}
            >
              RESERVE NOT MET
            </div>
          </div>
        );

      
      } else if (data.message === "NEXTSLOT"|| data.message === "PASS" ) {
        setTimeout(() => {
          // setImage([])
          return ListData();
        }, 1000);
      } else {
        setSold("");
      }

      setStatus(data.message);
    });

    // return () => socket.removeAllListeners()

  }, [details, socket]);

  const handleSwitch = () => {
    setSwitch(!switchMode);
  };


  const [open, setOpen] = React.useState(true);
  const handleClose = () => {
    setOpen(!open);
  };

  const [opendragg, setOpendragg] = React.useState(false);

  // const dragghandleClickOpen = () => {
  //   setOpendragg(true);
  // };

  const dragghandleClose = () => {
    setOpendragg(false);
  };


  return (
    <>
    


    {/* <Button onClick={dragghandleClickOpen} 
    variant="outlined" 
    startIcon={<PlayCircleIcon />}
    style={{ background: '#ce1b37',
    color: 'white',
    fontSize: 12,
    right:0,position: 'absolute',
    zIndex: 9,
    borderRadius:5,
    visibility: mediadQuery === false ? "hidden" : "vissible",}}>
     Watch live</Button> */}


 
              <BlinkedBox
                style={{
                  
                  fontSize: 18,
                  // visibility: status !== "" ? "visible" : "hidden",
                  // visibility:
                  //   status === "FAIR_WARNING" || status === "OPEN"
                  //     ? "visible"
                  //     : "hidden",
                }}
              >
                <div className="boxStatusOne" style={{ position: "static", marginTop: mediadQuery === false ? 15:0}}>
                  <div
                    className="boxStatus"
                    style={{
                        backgroundColor:
                        status === "FAIR_WARNING" ? "red" : "",
                        color: "white",
                    }}
                  >
                    <p style={{ margin: "auto",fontWeight: 'bold' }}>{   status === "FAIR_WARNING" ? status: ''}</p>
                  </div>
                </div>
              </BlinkedBox>
        
      {mediadQuery === false ? (
        <div >

{/* 
        <p
          gutterBottom
          style={{ fontWeight: "bold", textAlign: "center" }}
        >
          {titleAuction}
        </p> */}
        </div>
      ) : (
        ""
      )}

      <div >
        <div
          className=""
          style={{
            marginTop:10,
            maxWidth: mediadQuery === false ? "" : "100%",
            margin: mediadQuery === false ? "" : "auto",
          }}
        >
          <div
            className="container11"
            style={{
            
              // border: "1px solid rgb(204, 204, 204)",
              // height: mediadQuery === false ? 300 : 400,
              // width: mediadQuery === false ? 300 : "",
              width:
                mediadQuery === false
                  ? image.slice(1).length
                    ? "65%"
                    : switchMode === true
                    ? "80%"
                    : "100%"
                  : "50",
                 margin: mediadQuery === false ? "auto" : "",
              // border: "1px solid #ccc",
            }}
          >

            {mediadQuery === false ? (
              <div style={{   marginBottom: mediadQuery === false ? 0 : 0,border: "1px solid rgb(204, 204, 204)",}}>
                 <div style={{
                        // display: switchMode === true ? "inline-block" : "none", 
                         backgroundImage: `url(${image.length ? image[0].img_url : NoImage})`,
                        backgroundColor: "#ffffff",
                        width: "100%",
                        height:  mediadQuery === false ? 200 : 370,
                        // display: "inline-block",
                        backgroundSize: "contain",
                        backgroundPosition: "center center",
                        backgroundRepeat: "no-repeat",
                        padding: 10,
                         }} >
                 </div>

                {/* <img
                  style={{ display: switchMode === true ? "inline" : "none" }}
                  className="image11"
                  src={image.length ? image[0].img_url : NoImage}
                /> */}

                {/* <div
                  className="image11"
                  style={{ display: switchMode === true ? "none" : "inline-block" }}
                >
                  <video
                    style={{ width: "100%", paddingTop: 20 }}
                    loop
                    controls
                    autoPlay
                    muted
                    playsInline
                  ></video>
                </div> */}
              </div>
            ) : (
              <img
                // style={{display: switchMode === true ? 'inline': 'none'}}
                className="image11"
                src={image.length ? image[0].img_url : NoImage}
              />
            )}

            {switchMode === false ? "" : sold}
            {/* <div class="overlay_sold">Sold</div> */}
          </div>
          {/* <div style={{ display: image.slice(1).length ? "block" : "none", }}>
          <div style={{ display: switchMode === true ? "inline-block" : "none" }}> */}
            {/* <div
              className=""
              style={{
                display: image.slice(1).length ? "block" : "none",
                maxWidth: mediadQuery === false ? "" : "100%",
                
                // margin: mediadQuery === false ? '' : "auto",
              }}
            > */}

   
            {/* <div
                style={{
                  display: "inline-flex",
                  justifyContent: "space-between",
                  height: 100,
                  marginTop: 20,
                  overflow: "auto",
                  // width: mediadQuery === false ? 300 : "",
                  margin: mediadQuery === false ? "auto" : "",
                }}
              >
                {image.slice(1).length ? (
                  image
                    .slice(1)
                    .map((val, i) => (
                      <div
                      className="centerImageOne"
                      style={{
                        border: '1px solid rgb(232, 232, 232)',
                        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 5px',
                        display: switchMode === true ? "inline" : "none", 
                        backgroundImage: `url(${val.img_url})`,
                        backgroundColor: "#ffffff",
                        width: 100,
                        height: 100,
                        display: "inline-block",
                        backgroundSize: "contain",
                        backgroundPosition: "center center",
                        backgroundRepeat: "no-repeat",
                        padding: 10,
                        marginRight:5
                      }}
                    ></div>
                    
                    ))
                ) : ("" )}
              </div> */}
          {/* </div> */}

      
          
        </div>
      </div>

      {mediadQuery === false ? (
        <div>
         
        </div>
      ) : (
        <div style={{ padding: 10, marginTop: 5 ,overflow: 'auto',
          height: 500}}>
          <div>
            <div  style={{display: 'flex', justifyContent: 'space-between'}}>

   
            <p
              gutterBottom
              variant="h6"
              style={{ fontWeight: "bold",fontSize: 20 }}
            >
            Lot Details
            </p>
     
          <Button
          variant="contained"
            onClick={handleClose}
       
              style={{ fontWeight: "bold",fontSize: 12,textTransform: 'capitalize',height:25 }}
              startIcon={<MessageIcon style={{fontSize: 15 }}/>}
            >

<span> Chat with Us</span> 
            </Button>
            </div>
            <Divider />

            {getData.map((val, i) => {
              let data =
                val.signed_dated + val.medium + val.size + val.property;
              return (
                <div key={i}>
                  {/* {data.length > 1000} */}

                  <Typography style={{ marginTop: 10,fontSize: 'Roboto","Helvetica","Arial",sans-serif'  }}>
                    <Typography
                    
                      style={{ fontSize: 18, fontWeight: "bold",fontSize: 'Roboto","Helvetica","Arial",sans-serif' }}
                      dangerouslySetInnerHTML={{ __html: val.artist }}
                    ></Typography>
                    <Typography
                      style={{ fontSize: 18, fontStyle: "italic",fontSize: 'Roboto","Helvetica","Arial",sans-serif'  }}
                      dangerouslySetInnerHTML={{ __html: val.title }}
                    ></Typography>
                  </Typography>

                  <Typography>
                    <Typography
                      style={{ fontSize: 16,fontSize: 'Roboto","Helvetica","Arial",sans-serif' }}
                      dangerouslySetInnerHTML={{ __html: val.signed_dated }}
                    ></Typography>

                    <Typography
                      style={{ fontSize: 16,fontSize: 'Roboto","Helvetica","Arial",sans-serif'  }}
                      dangerouslySetInnerHTML={{ __html: val.medium }}
                    ></Typography>

                    <Typography
                      style={{ fontSize: 16,fontSize: 'Roboto","Helvetica","Arial",sans-serif' }}
                      dangerouslySetInnerHTML={{ __html: val.property }}
                    ></Typography>
                  </Typography>

                  {data.length > 1000 ? (
                    <div style={{ marginTop: 15 }}>
                      {" "}
                      <Button
                        variant="outlined"
                        onClick={handleMore}
                        style={{ textTransform: "capitalize" }}
                      >
                        {" "}
                        {more === false ? "Read more" : "Less"}
                      </Button>
                    </div>
                  ) : (
                    ""
                  )}
                  {/* <p style={{ fontSize: 16}}   dangerouslySetInnerHTML={{__html: val.medium}} ></p>
                <p style={{ fontSize: 16}}  dangerouslySetInnerHTML={{__html: val.size}} ></p>
                <p style={{ fontSize: 16}}>{val.property}</p> */}
                </div>
              );
            })}

            {/* <Divider></Divider> */}
          </div>
          {/* <Box style={{ marginTop: 15 }}>
            <p style={{ fontWeight: "bold" }}>
              <MessageIcon /> Announcement :
            </p>
            <p
              style={{ fontSize: 14, whiteSpace: "pre-line", marginTop: 10 }}
            >
              {announcement}
            </p>
          </Box> */}
        </div>
      )}

    <div
        style={{
          zIndex: 99999,
          // position: "relative",
          bottom: matchesPhone === true ? 550 : 0,
          display: open === false ? "block" : "none",
        }}
      >
        <div
          style={{
            position: "fixed",
            bottom: matchesPhone === true ? 0 : 100,
            right: '36%',
            width: '30%',
            marginBottom: 30,
          }}
        >
          <Drawer
          status={open}
            socket={socket}
            username={"deleonfsad@gmail.com"}
            room={22}
            handleClose={handleClose}
            sender={userID}
          />
        </div>
      </div>


    
      <Dialog
      
        open={opendragg}
        onClose={dragghandleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          {titleAuction}
        </DialogTitle>
        <DialogContent sx={{padding: '0px 6px'}}>
        <div style={{  width: 500,}}>
            <iframe
              id="ifvideo"
              width="100%"
              height={`${matchesPhone === true ? "380" : "100%"}`}
              scrolling="no"
              frameborder="0"
              allowfullscreen=""
              src="https://demo.nanocosmos.de/nanoplayer/embed/1.3.3/nanoplayer.html?entry.rtmp.streamname=TKGUW-bCyQT&amp;playback.latencyControlMode=balancedadaptive"
            ></iframe>
          </div>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={dragghandleClose}>
            Close
          </Button>
          {/* <Button onClick={handleClose}>Subscribe</Button> */}
        </DialogActions>
      </Dialog>



    </>
  );
}

export default Midlayout;

//"https://leongallery.sgp1.digitaloceanspaces.com/v2/private-sale/PRIVATE_SALE/69.jpg" "https://wallpapers.com/images/featured/hd-a5u9zq0a0ymy2dug.jpg"
